import React from 'react'
import Slider from "react-slick";
import { Link } from 'react-router-dom'
import { getAssetUrl } from "../../helper/BaseUrl";

export default function HomeBanner({homeData}) {
    const sliderData = homeData?.slider ?? [];

    const settings = {
        dots: false,
        arrows: false,
        infinite: sliderData.length > 1,
        speed: 2500,
        autoplaySpeed: 2000,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        pauseOnHover: false,
        cssEase: "ease",
        draggable: false,
        swipe: false,
    };

  return (
    <>
    <section className="banner-section">
        {sliderData.length > 0 && (
        <Slider {...settings}>
            {sliderData.map((item, index) => (
            <div className='banner-slidebox' key={index}>
                <img src={getAssetUrl(item?.image)} className="img-responsive banner-thumb" alt={item?.alt_image ?? "banner"} fetchpriority="high" loading="eager"/>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 col-md-8">
                            <div className="banner-head">
                               <span className="heading">{item?.title}</span>
                                <p>{item?.brief}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            ))}
        </Slider>
        )}

        <div className="banner-social">
            <ul>
                <li><a href={"https://www.instagram.com/nativesutra/"} target="_blank" rel="noopener noreferrer" aria-label="Instagram"><i className="fa-brands fa-instagram" aria-hidden="true"></i> </a></li>
                <li><a href={"https://www.facebook.com/nativesutra"} target="_blank" rel="noopener noreferrer" aria-label="Facebook"> <i className="fa-brands fa-facebook-f" aria-hidden="true"></i></a> </li>
                <li><Link to={"https://in.pinterest.com/nativesutra/"} target="_blank" rel="noopener noreferrer" aria-label="Pinterest"> <i className="fa-brands fa-pinterest-p" aria-hidden="true"></i> </Link> </li>

                {/* <li><Link to={"https://www.linkedin.com/company/nativesutra/"} target="_blank" aria-label="linkedin">   <i className="fa-brands fa-linkedin-in"></i>  </Link> </li>
                <li><Link to={"https://www.youtube.com/@nativesutra3728"} target="_blank" aria-label="youtube"><i className="fa-brands fa-youtube"></i> </Link></li> */}
            </ul>
        </div>
    </section> 
    </>
  )
}
